import $ from 'jquery';
import {LastViewedModule} from "../../services/lastViewed/LastViewed";

const addToLastViewedSemantics = {
    'mainWrapClass': 'add-to-last-viewed-v1',
    'instanceIdAttribute': 'data-instance-id',
    'isInLastViewedAttributeName': 'data-add-to-last-viewed-v1-is-in-last-viewed',
    'isInitializedAttribute': 'data-is-initialized',
    'productTypeIdAttributeName': 'data-add-to-last-viewed-v1-product-type-id',
    'idAttributeName': 'data-add-to-last-viewed-v1-id',
    'virtualModifierIdAttributeName': 'data-add-to-last-viewed-v1-virtual-modifier-id',
};

$(function () {
    AddToLastViewedV1.init();
});

class AddToLastViewedV1 {
    constructor() {
        this.pluginInstances = {};
    }

    static init() {
        if ($(`.${addToLastViewedSemantics.mainWrapClass}`).length === 0) {
            return false;
        }

        if (!window || !window.widgets || !window.widgets.addToLastViewedV1) {
            window.widgets.addToLastViewedV1 = new AddToLastViewedV1();
        }

        /**
         * Checking other instances
         */
        $(`.${addToLastViewedSemantics.mainWrapClass}`).each((index, el) => {
            let isInitialized =
                ($(el).attr(`${addToLastViewedSemantics.isInitializedAttribute}`) === 'true');
            if (!isInitialized) {
                window.widgets.addToLastViewedV1.registerInstance($(el));
                window.widgets.addToLastViewedV1.run($(el));
            }
        });
    }

    registerInstance(el) {
        let instanceId =
            el.attr(`${addToLastViewedSemantics.instanceIdAttribute}`) || false;

        if (instanceId === false) {
            throw new Error(`Invalid jQuery selector for ` +
                `instance with id [${instanceId}]`);
        }
        try {
            el.attr(`${addToLastViewedSemantics.isInitializedAttribute}`, true);
            window.widgets.addToLastViewedV1.pluginInstances[instanceId] = el;
        } catch (e) {
            el.hide();
            throw e;
        }
    }

    run(initiatorElement) {
        LastViewedModule.list.addOrChange(
            initiatorElement.attr(
                addToLastViewedSemantics
                    .productTypeIdAttributeName
            ),
            initiatorElement.attr(
                addToLastViewedSemantics
                    .idAttributeName
            ),
            initiatorElement.attr(
                addToLastViewedSemantics
                    .virtualModifierIdAttributeName
            ),
        );
    }
}